import React from "react";
import { useHistory } from "react-router-dom";
import qs from "qs";
import {
  WSBanner,
  WSCard,
  WSFlexBox,
  WSImage,
  WSList,
  WSPage,
  WSPageToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { useBrowserPageTitle } from "../../../../components/BrowserPageTitle/BrowserPageTitle";
import { WSQueries } from "../../../../query/WSQuery";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../../query/users/queries";
import { useQueryMeridioPlanCatalog } from "../../../../query/benefits/useQueryMeridioPlanCatalog";
import { openInNewTab } from "../../../../shared/utils/openInNewTab";
import MeridioHealthInsuranceImage from "../../assets/MeridioHorizontalLogo.png";
import {
  PATH_BENEFITS_INSURANCE,
  PATH_BENEFITS_MERIDIO_ENROLL,
  routeHelpersBenefitsInsuranceDetails
} from "../../paths";
import { MERIDIO_KEY } from "../../utils/constants";
import { PlanCategorySection } from "./PlanCategorySection";

export const RouteExploreMeridioPlans: React.FC = () => {
  const history = useHistory();
  const goToBenefitsInsuranceDetails =
    routeHelpersBenefitsInsuranceDetails.useGoTo();
  const userId = useUserId();
  const queryMemberProfile = useQueryMemberProfile(userId);
  const queryMeridioPlanCatalog = useQueryMeridioPlanCatalog();

  useBrowserPageTitle("Benefits - Explore Meridio Plans");

  const member = queryMemberProfile.data;
  const searchParams = member
    ? qs.stringify({
        name: {
          first: member.user.profile.firstName,
          last: member.user.profile.lastName
        },
        phoneNumber: member.user.phone.number?.substring(2),
        email: member.user.email,
        wingspanId: member.memberId
      })
    : "";
  const scheduleCallUrl = `https://bnfts.us/wingspan-onboard?${searchParams}`;

  return (
    <WSPage>
      <WSPageToolbar
        title="Explore plans"
        breadcrumbs={[
          {
            label: "Insurance",
            onClick: () => history.push(PATH_BENEFITS_INSURANCE)
          },
          {
            label: "Health Insurance",
            onClick: () =>
              goToBenefitsInsuranceDetails({
                tab: "all",
                benefit: MERIDIO_KEY
              })
          },
          { label: "Explore plans" }
        ]}
        actions={[
          {
            label: "Schedule call",
            buttonKind: "Primary",
            buttonIcon: "open-tab",
            onClick: () => openInNewTab(scheduleCallUrl)
          }
        ]}
      >
        <WSText.ParagraphSm color="gray500">
          Explore plans and enroll. You can add dependents during the enrollment
          process.
        </WSText.ParagraphSm>
      </WSPageToolbar>

      <WSCard
        mb="M"
        divider="bottom"
        actions={{
          orientation: "vertical",
          alignment: "fill",
          buttons: [
            {
              label: "Schedule call",
              kind: "Primary",
              icon: "open-tab",
              onClick: () => openInNewTab(scheduleCallUrl)
            },
            {
              label: "Start enrollment",
              kind: "Secondary",
              onClick: () => history.push(PATH_BENEFITS_MERIDIO_ENROLL)
            }
          ]
        }}
      >
        <WSList gap="M">
          <WSFlexBox.Center>
            <WSImage
              src={MeridioHealthInsuranceImage}
              placeholder="Meridio"
              width={300}
            />
          </WSFlexBox.Center>

          <WSBanner theme="neutral">
            Scheduling a call with Meridio is recommended to learn more about
            the plans and get started.
          </WSBanner>
        </WSList>
      </WSCard>

      <WSQueries queries={{ queryMeridioPlanCatalog }}>
        {({ queryMeridioPlanCatalogData }) => (
          <>
            {queryMeridioPlanCatalogData.categories.map(category => (
              <PlanCategorySection
                key={category.category}
                category={category}
              />
            ))}
          </>
        )}
      </WSQueries>
    </WSPage>
  );
};
